import {ASSET_PREFIX} from 'utils/constants';
import css from 'styled-jsx/css';
import Link from 'next/link';
import { useState } from "react";
import GenericModal from "components/GenericModal";
import AlternativeEntryMethod from "components/enter/AlternativeEntryMethod";

const PostalEntryBanner = ({ displayAsPopup = false, icon = `${ASSET_PREFIX}/images/enter/envelope.svg`, style }) => {
  const [showPopup, setShowPopup] = useState(false);

  const bannerContent = (
    <div className='container' style={style} onClick={() => displayAsPopup ? setShowPopup(true) : {}}>
      <img src={icon} style={{ marginBottom: '1.2em', width: '30px' }} />
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '1.5em' }}>
        OR... ENTER BY <strong>&nbsp;POST</strong> <img src={`${ASSET_PREFIX}/images/enter/right-arrow.svg`} style={{ marginLeft: '7px' }} />
      </div>

      <style jsx>{styles}</style>
    </div>
  );

  if (displayAsPopup) {
    return (
      <>
        { showPopup &&
          <GenericModal onClose={() => setShowPopup(false)}>
            <AlternativeEntryMethod />
          </GenericModal>
        }
        {bannerContent}
      </>
    );
  } else {
    return (
      <Link href={`/alternative-entry-method`}>
        {bannerContent}
      </Link>
    );
  }
};

const styles = css`
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 1em 0;
  cursor: pointer;
  
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 0.25em;
  font-size: 1em;
  font-weight: bold;
}
`;

export default PostalEntryBanner;
